import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export interface AnonymizationRequestResponse {
	message: string;
	status: 'pending';
	requestedAt: string;
	anonymizeAt: string;
	canCancelUntil: string;
	waitDays: number;
	remainingDays: number;
	jobTime: string;
}

export const useRequestAnonymization = () => {
	return useMutation({
		mutationFn: async (userId: string) => {
			try {
				return (await api.delete<AnonymizationRequestResponse>(`/user/anonymize/${userId}`)).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao solicitar exclusão da conta');
			}
		},
		onError: (error) =>
			console.error(
				'Erro ao solicitar exclusão da conta:',
				getApiErrorMessage(error, 'Erro ao solicitar exclusão da conta')
			),
	});
};
